import React from 'react'
import ModalWrap from './index'
import styles from './Modal.module.css'
import { MdDelete } from 'react-icons/md'
import { TiCancel } from 'react-icons/ti'
import BlueBtn from './../SidBarButtons/BlueBtn'
import { useTranslation } from 'react-i18next'

interface ModalType {
	setIsOpen: () => void
	title: string
	isOpen: boolean
	hundleTrue: () => void
}

function ConfirmModal({ setIsOpen, title, isOpen, hundleTrue }: ModalType) {
	const { t } = useTranslation()

	return (
		<>
			<ModalWrap setIsOpen={setIsOpen} title={title} isOpen={isOpen} id={44}>
				<div className={styles.confirm}>
					<BlueBtn title={t('st:button.del')} onclick={hundleTrue}>
						<MdDelete />
					</BlueBtn>

					<button className={styles.btn} onClick={setIsOpen}>
						{' '}
						<TiCancel className={styles.btnIcon} /> {t('st:button.cancel')}{' '}
					</button>
				</div>
			</ModalWrap>
		</>
	)
}

export default ConfirmModal
